export const metaMap: Record<string, { title: string; description: string }> = {
  'ppc-growth-annual': {
    title: 'Grow Faster with Signalytics PPC Growth Plan',
    description:
      'Advanced Amazon PPC optimization with our Growth Plan. Save big with our annual subscription and supercharge your campaign.',
  },
  'ppc-professionalPlus-annual': {
    title: 'Signalytics PPC Professional Plus – Annual Plan',
    description:
      'Join the top tier of Amazon advertisers. The Professional Plus plan offers full-scale PPC management, AI-driven insights, and expert strategy.',
  },
  'ppc-growth': {
    title: 'Signalytics PPC Growth Plan',
    description:
      'Get serious about scaling your Amazon ads. The Growth Plan delivers targeted PPC strategy and AI-powered insights to boost sales, month by month.',
  },
  'starter-annual': {
    title: 'Start Strong: Signalytics PPC Starter Plan',
    description:
      'Perfect for new Amazon sellers! Get full-year access to essential PPC tools and performance tracking at a discounted annual rate.',
  },
  'ppc-starter': {
    title: 'Signalytics PPC Starter Plan – Monthly Access',
    description:
      'Begin your PPC journey with confidence. The Starter Plan gives Amazon sellers a smart, low-risk way to start managing and improving ad campaigns.',
  },
  'ppc-starter-annual': {
    title: 'Signalytics Starter Plan – Affordable PPC Management',
    description:
      'Enjoy a full year of hands-on PPC support and performance tools tailored for beginner Amazon sellers. Annual savings included in the Starter Plan.',
  },
  'ppc-professional': {
    title: 'Signalytics PPC Professional Plan',
    description:
      'Designed for growing Amazon brands. The Professional Plan includes tailored campaign strategies, and advanced keyword targeting.',
  },
  'ppc-professionalPlus': {
    title: 'PPC Professional Plus Plan – Premium Amazon Ad Management',
    description:
      'Maximize ROI with our most powerful PPC plan. Gain monthly access to data-backed strategies, and competitive insights.',
  },
  professional: {
    title: 'Signalytics Professional Plan – Monthly PPC for Growth-Stage Sellers',
    description:
      'Push your Amazon ads to the next level. Our Professional Plan helps you scale with expert guidance, monthly audits, and AI-optimized strategies.',
  },
};
